import { BaseEntity } from "./BaseEntity";

export class ContractEntity extends BaseEntity {
    constructor() {
        super();

        this.entityName = "components.contract.contractList.contract";
        this.pageTitle = "components.contract.contractList.listContracts.PageTitle";
        this.menuPath = "/Resources";
        this.APIRoute = "Resources/Contracts"
        this.i18nBase = "components.contracts.listContracts";
        this.baseEndPoint = "contract";
        this.endpoints = {
            list: `${this.baseEndPoint}`,
            create: `${this.baseEndPoint}`,
            get: `${this.baseEndPoint}/:id`,
            getItems: `${this.baseEndPoint}/:id/items`,
            delete: `${this.baseEndPoint}/:id`,
            activate: `${this.baseEndPoint}/:id/activate`,
            deactivate: `${this.baseEndPoint}/:id/deactivate`
        };

        this.fieldsStep1 = [
            {
                key: "id",
                label: "user.fields.id",
                type: "hidden",
                visible: false,
                editable: false,
                orderBy: false
            },
            {
                key: "customer_name",
                label:  `${this.i18nBase}.client`,
                type: "text",
                visible: true,
                editable: true,
                cols: 6,
                path: ""
            },
            {
                key: "number",
                label: "common.labels.number",
                type: "text",
                visible: true,
                editable: true,
                cols: 3

            },
            {
                key: "contract_status",
                label:  "common.labels.status",
                type: "text",
                visible: true,
                cols: 3,
                path: "contract_status"
            },
            {
                key: "end_date",
                label: `${this.i18nBase}.validity`,
                type: "date",
                visible: true,
                editable: true,
                cols: 3,
                path: "end_date"
            },
            {
                key: "approval_date",
                label: `${this.i18nBase}.approvalDate`,
                type: "date",
                visible: true,
                editable: true,
                cols: 3,
                path: "approval_date"
            },
            {
                key: "start_date",
                label: "common.labels.dateStart",
                type: "date",
                visible: true,
                editable: true,
                cols: 3,
                path: "start_date"
            },
            {
                key: "suspension_date",
                label: `${this.i18nBase}.suspensionDate`,
                type: "date",
                visible: true,
                editable: true,
                cols: 3,
                path: "suspension_date"
            },
            {
                key: "customer_address_postal_code",
                label: "common.labels.postalCode",
                type: "text",
                visible: true,
                editable: true,
                cols: 2,
                maxlength: 9,
                path: "customer_address_postal_code"
            },
            {
                key: "customer_address_city_name",
                label: "common.labels.city",
                type: "text",
                visible: true,
                editable: true,
                cols: 4,
                path: "customer_address_city_name"
            },
            {
                key: "customer_address_city_state",
                label: "common.labels.stateAcronym",
                type: "text",
                visible: true,
                editable: true,
                cols: 1,
                maxlength: 2,
                path: "address.city.state"
            },
            {
                key: "customer_address_line1",
                label: "common.labels.streetAddress",
                type: "text",
                visible: true,
                editable: true,
                cols: 5,
                path: "customer_address_line1"
            },

            {
                key: "customer_address_district",
                label: "common.labels.neighborhood",
                type: "text",
                visible: true,
                editable: true,
                cols: 6,
                path: "address.district"
            },
            {
                key: "customer_address_line2",
                label: "common.labels.complement",
                type: "text",
                visible: true,
                required: false,
                editable: true,
                cols: 3
            },
            {
                key: "customer_address_detail",
                label: "common.labels.landmark",
                type: "text",
                visible: true,
                required: false,
                editable: true,
                cols: 3,
                path: "address.detail"
            },
        ]

        this.customActions = {
            duplicate: false
        }

        this.productColumns = [
            {
                key: "identity",
                label: "common.labels.code",
                visible: true,
                orderBy: false
            },
            {
                key: "name",
                label: "common.labels.name",
                visible: true,
                orderBy: false
            },
            {
                key: "price",
                label: "common.labels.price",
                visible: true,
                orderBy: false
            },
            {
                key: "max_download",
                label: "common.labels.maximumDownload",
                visible: true,
                orderBy: false
            },
            {
                key: "max_upload",
                label: "common.labels.maximumUpload",
                visible: true,
                orderBy: false
            },
            {
                key: "quantity",
                label: "common.labels.quantity",
                visible: true,
                orderBy: false
            },
            {
                key: "status",
                label: "common.labels.status",
                visible: true,
                orderBy: false
            },
        ]

        this.tableColumns = [
            {
                key: "number",
                label: `${this.i18nBase}.contractNumber`,
                width: "80px",
                smallScreenWidth: "100px",
                visible: true,
                orderBy: true
            },
            {
                key: "customer",
                label: `${this.i18nBase}.consumerName`,
                width: "190px",
                smallScreenMaxChars: 10,
                smallScreenWidth: "100px",
                maxChars: 44,
                visible: true,
                orderBy: false
            },
            {
                key: "tp_doc_identity",
                label: `${this.i18nBase}.typePfPj`,
                visible: true,
                orderBy: false
            },
            {
                key: "contract_status",
                label: `${this.i18nBase}.status`,
                visible: true,
                orderBy: false
            },
            {
                key: "city",
                label: `${this.i18nBase}.city`,
                width: "80px",
                maxChars: 20,
                smallScreenMaxChars: 10,
                visible: true,
                orderBy: false
            },
            {
                key: "start_date",
                label: "common.labels.dateStart",
                width: "80px",
                smallScreenWidth: "80px",
                visible: true,
                orderBy: true
            },
            {
                key: "value",
                label: `${this.i18nBase}.value`,
                visible: true,
                orderBy: false
            },
            {
                key: "actions",
                label: "common.labels.actions",
                visible: true,
                orderBy: false
            },
        ]

        this.pages = {
            view: {
                pageTitle: `${this.i18nBase}.contract`,
                pathI18n: `components.settings.permissionManagement.menuList.Contracts/${this.i18nBase}.pageTitle`,
                route: ["/contracts","/contracts/contract-list", "/contracts/view/:id"]
            },
            list: {
                pageTitle: `${this.i18nBase}.pageTitle`,
                pathI18n: "components.settings.permissionManagement.menuList.Contracts",
                route:  ["/contracts","/contracts/contract-list"],
                filters: {
                    quickSearch: {
                        info: "common.messages.info.searchByName",
                        searchBy: ["name"],
                        type: "text",
                    },
                    advanced: {
                        fields: [
                            {
                                key: "number",
                                label: `${this.i18nBase}.contractNumber`,
                                type: "text",
                                cols: 12,
                                path: "number"
                            },
                            {
                                key: "contract_status",
                                label: `${this.i18nBase}.status`,
                                type: "select",
                                searchHandler: "contractStatusList",
                                cols: 6,
                                options: [],
                                path: "contract_status"
                            },
                            {
                                key: "city_id",
                                label: `${this.i18nBase}.city`,
                                type: "autocomplete",
                                searchHandler: "cityList",
                                cols: 6,
                                path: "city_id"
                            },
                            {
                                key: "start_date",
                                label: `${this.i18nBase}.startDate`,
                                type: "date",
                                cols: 6,
                                path: "start_date"
                            },
                            {
                                key: "end_date",
                                label: `${this.i18nBase}.endDate`,
                                type: "date",
                                cols: 6,
                                path: "end_date"
                            },

                        ],
                    },
                },
            },
        };
    }

    getUrl(endpoint, params = {}) {
        let url = endpoint;
        Object.keys(params).forEach(key => {
            url = url.replace(`:${key}`, params[key]);
        });
        return url;
    }
}
